import Controller from "app/controllers/Controller";
import CheckMyNumbersView from "app/views/CheckMyNumbers";

class CheckMyNumbersController extends Controller {

    constructor(appCtx) {
        super(appCtx, new CheckMyNumbersView());
    }

    exitRoute(next) {
        // do nothing
        if(next) { 
            next();
        }
    }

}

export default CheckMyNumbersController;
